import { ImportDropTarget } from "./import-drop-target";
import { EventContext } from "@/domains/metrics/context";
import { importDroppedItems } from "@/modules/importing/drop-and-drop-markdown";
import { toastModule } from "@/modules/toast";
import { useAppStore } from "@/store";
import { pluralize } from "@/modules/pluralize";
import { useCallback, useState } from "react";
import { DropItem, DropZone } from "react-aria-components";

interface Props {
  onDrop: (items: DropItem[]) => boolean | void;
}

export const DropTargetStep: React.FC<Props> = ({ onDrop }) => {
  const { store } = useAppStore();
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDrop = useCallback(
    (e: { items: DropItem[] }) => {
      setIsDragOver(false);
      const isBlocked = onDrop(e.items) === false; // if onDrop callback returns anything except false, then we continue
      if (!isBlocked) {
        importDroppedItems(e.items, store, EventContext.GlobalActions);
        toastModule.triggerToast({
          content: `Bringing in ${e.items.length} ${pluralize(e.items.length, "file", "files")}. Your import will continue in the background.`,
        });
      }
    },
    [store, onDrop]
  );

  const handleDropEnter = useCallback(() => {
    setIsDragOver(true);
  }, []);

  const handleDropExit = useCallback(() => {
    setIsDragOver(false);
  }, []);

  return (
    <DropZone onDrop={handleDrop} onDropEnter={handleDropEnter} onDropExit={handleDropExit}>
      <ImportDropTarget isActive={isDragOver} />
    </DropZone>
  );
};
